// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1M5hE","colMin":"styles_colMin__3Kwh7"};